import { createSlice } from "@reduxjs/toolkit";

export const contractSlice = createSlice({
	name: "contract",
	initialState: {
		editFormContract: null,
		FormContractInfo: [],
	},
	reducers: {
		editFormContract: (state, { payload: values }) => ({
			...state,
			editFormContract: values,
		}),
		setValueFormContract: (state, { payload: values }) => ({
			...state,
			FormContractInfo: values,
		}),
		addFormContract: (state, { payload: values }) => {
			return {
				...state,
				FormContractInfo: [...state.FormContractInfo, values],
			};
		},
	},
});
export const { editFormContract, setValueFormContract, addFormContract } =
	contractSlice.actions;
export default contractSlice.reducer;
